import { useState, FormEvent } from 'react';
import { t, useTranslation } from '../i18n';

interface Props {
  contacts: string[];
  onCancel: () => void;
  onCreate: (name: string, memberIds: string[]) => void;
}

export default function CreateGroupModal({ contacts, onCancel, onCreate }: Props) {
  useTranslation();
  const [name, setName] = useState('');
  const [filter, setFilter] = useState('');
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const filtered = contacts.filter((c) => c.toLowerCase().includes(filter.toLowerCase()));

  function toggle(id: string) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }

  function submit(e: FormEvent) {
    e.preventDefault();
    if (!name.trim() || selected.size === 0) return;
    onCreate(name.trim(), Array.from(selected));
  }

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{t('modal.group.title')}</h2>
        <p className="hint">{t('modal.group.hint')}</p>
        <form onSubmit={submit}>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t('modal.group.namePh')}
            maxLength={64}
            required
          />
          <input
            type="text"
            placeholder={t('modal.share.filter')}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            autoCapitalize="none"
            autoCorrect="off"
            style={{ marginTop: 8 }}
          />
          <ul className="share-contact-list">
            {filtered.length === 0 && <li className="empty-row">{t('modal.share.empty')}</li>}
            {filtered.map((c) => (
              <li key={c}>
                <button type="button" className="ghost" onClick={() => toggle(c)}>
                  <span style={{ marginRight: 10 }}>{selected.has(c) ? '☑' : '☐'}</span>
                  {c}
                </button>
              </li>
            ))}
          </ul>
          <div className="hint">{t('modal.group.selected', selected.size)}</div>
          <div className="modal-actions">
            <button type="button" className="ghost" onClick={onCancel}>{t('common.cancel')}</button>
            <button type="submit" className="primary" disabled={!name.trim() || selected.size === 0}>
              {t('modal.group.create')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
